import api from '../api';

export const getMessagesNotAnswered = filters =>
  api.request({
    url: `chat/messages/unresponded`,
    method: 'GET',
    params: filters,
  });
